<bread-crumb></bread-crumb>

<!-- MODELS MANAGEMENT -->
<div fxLayout="row wrap" class="zero" fxLayoutAlign="center" style="padding-top: 20px;">

  <div
      fxFlex="25" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxLayout="column" style="padding: 5px;"
  >

    <mat-card class="card option-card width-field-100 pointer">
      <mat-card-content class="card-content dashboard-card-content t_center">
          <i class="material-icons medium_icon  pointer" [routerLink] = "['/dashboard/admin/users']" >account_box</i>
          <h3> {{ "admin.users" | translate }} </h3>
      </mat-card-content>
    </mat-card>

  </div>

  <div fxFlex="25" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxLayout="column" style="padding: 5px;">
                    
    <mat-card class="card option-card width-field-100 pointer">
        <mat-card-content class="card-content t_center">
            <i class="material-icons medium_icon pointer" [routerLink] = "['/dashboard/admin/zimbrainstance']" >email</i>
            <h3> {{ "zimbrainstance.manage" | translate }} </h3>
        </mat-card-content>
    </mat-card>

  </div>
  
  <div fxFlex="25" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxLayout="column" style="padding: 5px;">
  
      <mat-card class="card option-card width-field-100 pointer">
        <mat-card-content class="card-content dashboard-card-content t_center">
            <i class="material-icons medium_icon  pointer" [routerLink] = "['/dashboard/admin/audit']" >assignment</i>
            <h3> {{ "admin.audit" | translate }} </h3>
        </mat-card-content>
      </mat-card>

  </div>

</div>


<div fxLayout="row wrap" class="zero" fxLayoutAlign="center" style="padding-top: 20px;">

  <div fxFlex="25" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxLayout="column" style="padding: 5px;">
                    
    <mat-card class="card option-card width-field-100 pointer">
        <mat-card-content class="card-content t_center">
            <i class="material-icons medium_icon pointer" (click)="zimbraLogin()">email</i>
            <h3> ZIMBRA LOGIN TEST </h3>
        </mat-card-content>
    </mat-card>

  </div>

</div>
